<template>
  <div class="location-popover-content">
    <div v-if="historyList.length > 0" class="history-wrap">
      <div class="section mb-[16px] flex items-center justify-between">
        <div class="section-title">历史搜索</div>
        <font-icon
          class="search-icon"
          icon="icon-shanchu"
          @click.stop="handleDelete"
        />
      </div>
      <searchHistory :list="historyList" @select="handleSelectHistory" />
    </div>

    <div
      v-if="historyList.length > 0 && tabList.length > 0"
      class="placeholder"
    />

    <div v-if="tabList.length > 0">
      <cityPanel
        :tabList="tabList"
        :showGroupName="false"
        @select="handleSelectCity"
      />
    </div>

    <div v-if="isLoading" class="loading-state">
      <el-skeleton :rows="5" animated />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ElMessageBox } from "element-plus";
import { storeToRefs } from "pinia";
import { onMounted, reactive, ref } from "vue";

import { getCityList } from "@/api/rest/common";
import { useHotelStoreHook } from "@/distributions/consumer/y/store/hotel";

import cityPanel from "./components/cityPanel.vue";
import searchHistory from "./components/searchHistory.vue";
import { ICity } from "./types";

const emit = defineEmits(["select"]);

const YHotelStore = useHotelStoreHook();
const { historyList } = storeToRefs(YHotelStore);

const tabList = reactive([
  {
    name: "国内热门城市",
    groups: []
  },
  {
    name: "国际热门城市",
    groups: []
  }
]);
const hotCityList = ref([]);
const isLoading = ref(true);
const filterCityList = (
  list: ICity[],
  filterCountry: string[],
  includes: Boolean = true
) => {
  return list.filter(item =>
    includes
      ? filterCountry.includes(item.country)
      : !filterCountry.includes(item.country)
  );
};

const initGetCityList = async cityList => {
  hotCityList.value = cityList;
  if (!tabList[0].groups.length)
    tabList[0].groups.push({
      label: "热门城市",
      list: filterCityList(hotCityList.value, ["中国", "中国台湾"])
    });

  if (!tabList[1].groups.length)
    tabList[1].groups.push({
      label: "热门城市",
      list: filterCityList(hotCityList.value, ["中国", "中国台湾"], false)
    });
};

const handleDelete = () => {
  ElMessageBox.confirm("确定删除历史记录？").then(() => {
    YHotelStore.deleteHistory();
  });
};
const handleSelect = item => {
  emit("select", item);
};

const handleSelectCity = item => {
  handleSelect({
    type: "city",
    data: item
  });
};

const handleSelectHistory = item => {
  handleSelect({
    type: "history",
    data: item
  });
};
onMounted(async () => {
  isLoading.value = true;
  try {
    const [_, cityData] = await Promise.all([
      YHotelStore.getSearchHistory(),
      getCityList({ hot: true })
    ]);
    await initGetCityList(cityData);
  } catch (error) {
    console.error("Failed to load discovery data:", error);
  } finally {
    isLoading.value = false;
  }
});
</script>

<style lang="scss" scoped>
.location-popover-content {
  .search-icon {
    font-size: 16px;
    cursor: pointer;
  }
  .section-title {
    font-size: 16px;
    color: #000b1e;
    font-family: var(--y-regular-font);
  }
  .placeholder {
    width: 100%;
    height: 10px;
    background: #fafafa;
  }
  .history-wrap {
    padding: 24px 24px 20px;
  }
}
</style>
